import { render } from "./Handling.vue?vue&type=template&id=4af8af0d&scoped=true"
import script from "./Handling.vue?vue&type=script&lang=js"
export * from "./Handling.vue?vue&type=script&lang=js"

import "./Handling.vue?vue&type=style&index=0&id=4af8af0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af8af0d"],['__file',"src/views/tcp/Handling.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4af8af0d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4af8af0d', __exports__)) {
    api.reload('4af8af0d', __exports__)
  }
  
  module.hot.accept("./Handling.vue?vue&type=template&id=4af8af0d&scoped=true", () => {
    api.rerender('4af8af0d', render)
  })

}


export default __exports__